import React, { useEffect } from "react";

const LogoutPage = () => {
  useEffect(() => {
    // Clear user data from localStorage or state management
    localStorage.removeItem("userInfo");
    localStorage.removeItem("token");

    // Optionally, redirect to the home page or login page
    window.location.href = "/login";
  }, []);

  return <></>;
};

export default LogoutPage;
